
const fields = [
  {
    type: 'bsx-label',
    label: 'ID',
    model: 'id',
    visible: (model) => model.id,
  },
  {
    type: 'bsx-label',
    inputType: 'text',
    label: '科別',
    model: 'name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '科別關鍵字設定',
    model: 'mapping_keywords',
    placeholder: '科別關鍵字設定',
    hint: "關鍵字請用「,」隔開，且不需留空白，一個關鍵字上限為 15 字元（例：神經內科,神內）",
  }
];

export default fields;
